import { toast as sonnerToast } from 'sonner';

/**
 * Toast helper — thin wrapper over `sonner` that picks the project's
 * defaults (top-right placement, consistent timing) and pins all
 * Spanish copy in one file so the FE never improvises a string at the
 * call site.
 *
 * Errors dismiss after 5s; success/info after 3s. Loading toasts
 * stay until dismissed or replaced by another call.
 *
 * Usage:
 *   import { toast } from '@/lib/sonner';
 *   toast.success('Inicio de sesión correcto');
 *   toast.error('Credenciales inválidas');
 *   toast.promise(signin(), { loading: '…', success: '…', error: '…' });
 */
const DEFAULTS = {
  duration: 4000,
  position: 'top-right' as const,
  richColors: true,
};

export const toast = {
  success(message: string, opts?: Parameters<typeof sonnerToast.success>[1]) {
    return sonnerToast.success(message, { ...DEFAULTS, ...opts, duration: 3000 });
  },
  error(message: string, opts?: Parameters<typeof sonnerToast.error>[1]) {
    return sonnerToast.error(message, { ...DEFAULTS, ...opts, duration: 5000 });
  },
  info(message: string, opts?: Parameters<typeof sonnerToast.info>[1]) {
    return sonnerToast.info(message, { ...DEFAULTS, ...opts, duration: 3000 });
  },
  warning(message: string, opts?: Parameters<typeof sonnerToast.warning>[1]) {
    return sonnerToast.warning(message, { ...DEFAULTS, ...opts, duration: 4000 });
  },
  promise: sonnerToast.promise,
  dismiss: sonnerToast.dismiss,
};
